import type { FC, ReactNode } from 'react';

import type { GraphSidePanelContentId } from '@ipfabric/utils';
import classNames from 'classnames';

interface Props {
  active: boolean;
  iconActive: ReactNode;
  iconHover: ReactNode;
  icon: ReactNode;
  label: string | ReactNode;
  onIconClick: (tabId: GraphSidePanelContentId) => void;
  tabId: GraphSidePanelContentId;
}

export const GraphSideTab: FC<Props> = (props) => {
  return (
    <div
      className={classNames(
        'graph-side-panel__icon',
        props.active && 'graph-side-panel__icon--active',
      )}
      onClick={() => props.onIconClick(props.tabId)}
    >
      <div className='mb-lgu-2 text-center'>
        {props.active ? (
          props.iconActive
        ) : (
          <div>
            {props.icon}
            {props.iconHover}
          </div>
        )}
      </div>
      <div
        className={classNames(
          'leading-lgu-7 text-center',
          props.active && 'font-semibold',
        )}
      >
        {props.label}
      </div>
    </div>
  );
};
